import { MaterialIcon } from '@components/common/MaterialIcon';
import { useSidebar } from '@hooks/useSidebar';
import type React from 'react';
import { useTranslation } from 'react-i18next';

export const SidebarCollapseToggle: React.FC = () => {
  const { sideBarOpen, toggleSideBar } = useSidebar();
  const { t } = useTranslation();

  return (
    <button
      type='button'
      onClick={() => toggleSideBar()}
      aria-label={t(
        sideBarOpen ? 'sidebar.toggle.collapse' : 'sidebar.toggle.expand',
      )}
      className='flex items-center justify-center flex-shrink-0 p-1 rounded border-0 bg-transparent cursor-pointer text-gray-500 hover:text-gray-700 hover:bg-primary-hover focus:outline-none focus-visible:outline-none'>
      <MaterialIcon
        icon={sideBarOpen ? 'chevron_left' : 'chevron_right'}
        classes={['text-base', 'leading-none']}
      />
    </button>
  );
};

export default SidebarCollapseToggle;
